// PROMPT 3.2 §B — Quiz service categories loader.
// STRICT: reads exclusively from /lib/catalog/categories.js — never from
// Shopify Collection handles. Crash with a friendly error if categories.js
// returns an empty list; do NOT fall back to a collection-based fetch.
//
// The Shopify GraphQL field consumed by downstream product queries is
// `productType` (the singular type field on the Product node). See
// /backend/catalog.py QUIZ_QUERY for the corresponding server-side query.

import { listCategories } from "../catalog/categories";

export class QuizCategoriesEmptyError extends Error {
        constructor() {
                super(
                        "The configurator is temporarily unavailable — no categories are configured. " +
                        "Contact ops so we can restore the catalog SSOT."
                );
                this.name = "QuizCategoriesEmptyError";
        }
}

/**
 * Load the strict category list for the quiz.
 * NOTE: This function must be the single source consumed by the quiz UI.
 * Adding a Shopify collection-based fallback here is a HARD violation of
 * PROMPT 3.2 §B and will fail T21.
 */
export function loadQuizCategories() {
        const cats = listCategories();
        if (!Array.isArray(cats) || cats.length === 0) {
                throw new QuizCategoriesEmptyError();
        }
        // Return only the fields the quiz needs. The `productType` here is the
        // GraphQL `Product.productType` field name — NOT a Shopify Collection
        // handle.
        return cats.map((c) => ({
                id: c.id,
                productType: c.product_type,
                title: c.title,
                subline: c.subline,
        }));
}
